module.exports = __webpack_public_path__ + "static/media/Industriekessel_04.8e691050.jpg";